module.exports = __webpack_public_path__ + "img/diamonds.a22cd32.webp";